import cn from 'classnames';
import { HTMLAttributes, useMemo } from 'react';
import { IAgriculture, ICultureParamData } from '@@/agriculture/ts';

import styles from './index.module.sass';

export function AgricultureParametersList(props: IAgricultureParametersListProps) {
  const { className, culture, params, ...rest } = props;
  const rootClass = cn(styles.root, className);

  const valuesByParamName = useMemo(
    () =>
      culture.parameters.reduce(
        (acc, param) => ({
          ...acc,
          [param.name]: params.find(({ name }) => name === param.name)?.value ?? '-',
        }),
        {} as Record<string, string | number>,
      ),
    [culture, params],
  );

  return (
    <div className={rootClass} {...rest}>
      {culture.parameters.map((param) => (
        <div className={styles.param} key={param.name}>
          <span className={styles.param__name}>
            {param.name} ({param.units})
          </span>

          <span className={styles.param__value}>{valuesByParamName[param.name]}</span>
        </div>
      ))}
    </div>
  );
}

export interface IAgricultureParametersListProps
  extends HTMLAttributes<HTMLDivElement> {
  culture: IAgriculture;
  params: ICultureParamData[];
}
